import { store, persistor } from '../app/store';
import { setLogoutAddresss } from '../reducers/addressesSlice';
import { setLogoutBookings } from '../reducers/bookingsSlice';
import { setLogoutBusiness } from '../reducers/businessSlice';
import { setLogoutBuyNumbers } from '../reducers/buyNumberSlice';
import { setLogoutCalls } from '../reducers/callSlice';
import { setLogoutChat } from '../reducers/chatSlice';
import { setLogoutCommunications } from '../reducers/communicationsSlice';
import { setLogoutContacts } from '../reducers/contactsSlice';
import { setLogoutCustomers } from '../reducers/customersSlice';
import { setLogoutEmployees } from '../reducers/employeesSlice';
import { setLogoutNavPath, setLogoutGlobal } from '../reducers/globalSlice';
import { setLogoutNumbers } from '../reducers/numbersSlice';
import { setLogoutReceptionist } from '../reducers/receptionistSlice';
import { resetAiConfig } from '../reducers/aiConfigSlice';

const PERSIST_STORAGE_KEY = 'persist:project-secretary-root-v2';
const PORTAL_ONBOARDING_TRANSITION_SESSION_KEY = 'portal-onboarding-transition';
const PORTAL_STORAGE_KEY_PREFIXES = [
    'project-secretary:',
    'project-secretary.',
    'project-secretary-',
];

const isPortalStorageKey = (key: string) =>
    key === PERSIST_STORAGE_KEY ||
    key === PORTAL_ONBOARDING_TRANSITION_SESSION_KEY ||
    PORTAL_STORAGE_KEY_PREFIXES.some(prefix => key.startsWith(prefix));

const removeMatchingStorageKeys = (storage: Storage) => {
    const keysToRemove: string[] = [];
    for (let index = 0; index < storage.length; index += 1) {
        const key = storage.key(index);
        if (key && isPortalStorageKey(key)) {
            keysToRemove.push(key);
        }
    }

    keysToRemove.forEach(key => storage.removeItem(key));
};

const clearPortalBrowserStorage = () => {
    try {
        removeMatchingStorageKeys(window.localStorage);
        removeMatchingStorageKeys(window.sessionStorage);
    } catch (error) {
        console.warn('Unable to clear portal browser storage during logout.', error);
    }
};

export function logout() {
    persistor.pause();

    // Remove branded stylesheet if present
    const brandNodes = (window as any).__brandStyleNodes as (HTMLLinkElement | HTMLStyleElement)[] | undefined;
    brandNodes?.forEach(node => node.parentNode?.removeChild(node));
    const brandLink = document.getElementById('business-stylesheet');
    brandLink?.parentNode?.removeChild(brandLink);
    (window as any).__brandStyleNodes = [];
    (window as any).__brandStylesheetId = undefined;

    store.dispatch(setLogoutAddresss());
    store.dispatch(setLogoutBookings());
    store.dispatch(setLogoutBusiness());
    store.dispatch(setLogoutBuyNumbers());
    store.dispatch(setLogoutCalls());
    store.dispatch(setLogoutChat());
    store.dispatch(setLogoutCommunications());
    store.dispatch(setLogoutContacts());
    store.dispatch(setLogoutCustomers());
    store.dispatch(setLogoutEmployees());
    store.dispatch(setLogoutGlobal());
    store.dispatch(setLogoutNumbers());
    store.dispatch(setLogoutReceptionist());
    store.dispatch(resetAiConfig());
    store.dispatch(setLogoutNavPath('/'));
    // Clear RTK Query cache so queries refetch after next login.
    // Avoid importing apiSlice here to prevent a circular dependency.
    store.dispatch({ type: 'api/resetApiState' });
    clearPortalBrowserStorage();
    void persistor.purge().finally(() => {
        clearPortalBrowserStorage();
        persistor.persist();
    });
}
